export const formatINR = (amount) => {
    const n = Number(amount || 0);
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
    }).format(n);
};

export const resolveImage = (src) => {
    // Prefer transparent, background-removed cut-outs for uniform product tiles.
    if (!src) return '/products/cutout/detergent-liquid-bottle.png';
    const m = src.match(/\/products\/([^/]+)\.(jpg|jpeg|png|webp)$/i);
    if (m) return `/products/cutout/${m[1]}.png`;
    return src;
};

// Normalise API errors (incl. FastAPI/Pydantic validation arrays) into a safe display string.
export const getErrorMessage = (e, fallback = 'Something went wrong. Please try again.') => {
    const detail = e?.response?.data?.detail;
    if (!detail) return e?.message && typeof e.message === 'string' && e.message !== 'Network Error' ? fallback : fallback;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        const msgs = detail.map((d) => (typeof d === 'string' ? d : d?.msg)).filter(Boolean);
        return msgs.length ? msgs.join(', ') : fallback;
    }
    if (typeof detail === 'object' && detail.msg) return detail.msg;
    return fallback;
};
